import moment from 'moment';
import _ from 'underscore';
import parseError from '../../parseError';
import { Toast } from '../../../../../../Components/Notification';
import getOffsetTime from '../../../../../../utils/getOffsetTime';

const updateMeal = async ({ state, userId, editMeal, updateState, refreshPage }) => {
  const { itemDetails } = state;
  const { tourId, mealId, jobElementId,
  OTE, billable, autoAdd } = itemDetails;

  let { mealStartTime, mealEndTime } = itemDetails;

  const parameters = {
    mealId,
    tourId,
    userId,
    startTime: mealStartTime.format('YYYY-MM-DD HH:mm:SS'),
    endTime: mealEndTime.format('YYYY-MM-DD HH:mm:SS'),
    jobElementId: jobElementId || -1,
    OTE,
    billable,
    autoAdd
  };

  // update meal
  const { resource } = state;
  const date = moment(mealStartTime).format('M/D/YYYY (ddd)');
  let notification = {type: 'success', message: 'Meal Updated', description: `For ${resource.name} on ${date}`};
  try {
    await editMeal(parameters);
  }
  catch(error) {
    if (!_.isEmpty(error)) {
      updateState({
        crudError: {
          failedAction: 'editMeal',
          message: parseError(error)
        }
      });
      console.log(error);
      notification = {
        type: 'error',
        message: "Updating Meal Failed",
        description: `For [${resource.name} on ${date}]: ${parseError(error)}`
      };
    }
  }
  Toast(notification);
  refreshPage();
}

export default updateMeal;



// WEBPACK FOOTER //
// ./src/Components/Schedule/LiveScheduleUpdate/utils/CRUD/meal/updateMeal.js